import React, { Component } from "react";

export default class LoadingIndicator extends Component {
  render() {
    return (
      <div
        className="col-lg-12"
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: this.props.marginTop,
          marginBottom: this.props.marginBottom,
          backgroundColor: `${this.props.backgroundColor ?? "#f3f3f4"}`,
        }}
      >
        <h1 className="fadingLoading">{this.props.message ?? "Loading..."}</h1>
      </div>
    );
  }
}
